export default {
  'page-title': 'Système d\'Autorisation de Retour de Marchandise (RMA) - Creative Labs (France)',
  'page-desc': 'Check the status of your return request with your RMA number. ',
  'mode-of-contact': 'Mode de contact',
  'your-details': 'Vos détails',
  'rma-request': 'Demande de RMA',
  'first-name': 'Prénom',
  'last-name': 'Nom',
  'enter-first-name': 'Entrez votre prénom',
  'enter-last-name': 'Entrez votre nom',
  'email-address': 'Adresse e-mail',
  'enter-email': 'Veuillez saisir votre adresse e-mail',
  'enter-valid-email': 'Veuillez s\'il vous plaît saisir une adresse e-mail valide',
  'enter-pid': 'Please enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': 'Produits',
  'sale': 'Soldes',
  'help': 'Aide',
  'sign-in': 'Connexion',
  'account': 'Compte',
  'loading-page': 'CHARGEMENT',
  'orders': 'Commandes',
  'membership-program': 'Programme d\'adhésion',
  'account-profile': 'Profil du compte',
  'contact-us': 'Nous contactez',
  'sign-out': 'Deconnexion',
  'recent-orders': 'Commandes récentes',
  'view-all-orders': 'Afficher toutes les commandes',
  'email_registered': {
    'text1': 'Cet e-mail a déjà été enregistré ',
    'link': 'Connexion',
    'text2': ' pour récupérer l\'historique de vos commandes'
  },
  'country-region': 'Pays / Région',
  'select-country': 'Veuillez sélectionner un pays',
  'preferred-language': 'Langue de réponse souhaitée',
  'select-language': 'Veuillez sélectionner la langue',
  'next': 'Suivant',
  'encountered-error': 'Nous avons rencontré une erreur. Veuillez réessayer',
  'your-enquiry': 'Votre demande',
  'nature-enquiry': 'Nature de la requête',
  'order-number': 'Numéro de commande',
  'order-id': 'Amazon ID de commande',
  'for-amazon-order': 'Pour les commandes passées via Amazon',
  'enter-order-number': 'Veuillez saisir votre numéro de commande',
  'rma-number': 'Numéro de RMA',
  'enter-rma-number': 'Veuillez entrer votre numéro RMA',
  'purchase_creative_com': {
    'text': 'Si votre produit défectueux a été acheté sur Creative.com ',
    'link': 'demandez un remplacement ici'
  },
  'not-purchase-creative-com': '<p>Si vous n\'avez pas acheté directement sur Creative.com, veuillez contacter votre revendeur directement pour les demandes de retour.</p><p><a href="https://fr.creative.com/help/garantie-et-retours" target="_blank">Cliquez ici pour plus d\'informations sur la garantie et le retour.</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'Si vous n\'avez pas acheté directement auprès de Creative.com, veuillez contacter votre revendeur directement pour les demandes de remplacement.',
  'not_purchase_creative_com_2': {
    'text': 'Si votre produit défectueux n\'a pas été acheté directement sur Creative.com, ',
    'link': 'demandez un remplacement ici'
  },
  'order-not-found': 'Ce numéro de commande n\'appartient pas à cette adresse e-mail. Veuillez réessayer.',
  'rma-not-found': 'Le numéro RMA que vous avez entré ne figure pas dans nos dossiers. Veuillez saisir un numéro RMA valide.',
  'previous-order': 'Commande précédente',
  'next-order': 'Commande suivante',
  'add-your-product': 'Ajoutez votre produit',
  'search-by-name': 'Recherche par nom de produit',
  'select-product': 'Veuillez sélectionner un produit.',
  'upload-proof-update-date': {
    'text1': 'Veuillez fournir votre preuve d\'achat ainsi que la date d\'achat. <br/>Si vous n\'avez pas votre preuve d\'achat, veuillez nous contacter ici. ',
    'link': 'nous contacter',
    'text2': ' ici.'
  },
  'return-product': 'Retourner le produit',
  'return-products': 'Retourner le produit(s)',
  'replace-defective-product': 'Remplacer le produit défectueux',
  'check-rma-status': 'Vérifier le statut RMA',
  'service-request': 'Demande (s) de service disponible',
  'select-one-service': 'Veuillez sélectionner une demande de service. Si vous avez plusieurs demandes de service pour la même commande, veuillez émettre une demande de service différente pour chaque problème.',
  'select-one-servcie-2': 'Veuillez sélectionner une demande de service.',
  'refund-products': 'Produit (s) pour remboursement',
  'qualifies-refund': 'Seul {refundNotAvailable} donne droit à un remboursement par la garantie de satisfaction. <br /> Veuillez modifier vos produits avant de continuer.',
  'replace-products': 'Remplacer le(s) produit(s) défectueux',
  'qualifies-replace': 'Seul {repairNotAvailable} est éligible pour un remplacement. <br /> Veuillez modifier vos produits avant de continuer.',
  'contact-us-assistance': 'Contactez-nous pour assistance',
  'return-information': 'Informations de retour',
  'replacement-information': 'Informations de remplacement',
  'fill-in-all': 'Veuillez remplir tous les champs de cette section.',
  'message': 'Message',
  'enter-message': 'Veuillez saisir votre message.',
  'submit': 'Soumettre',
  'submission-successful': 'Votre soumission a été soumise.',
  'contact-us-thank-you': 'Nous vous répondrons dans les 2 jours ouvrables.',
  'back-to-home': 'Retour à la page d’acceuil',
  'confirmation': 'Confirmation',
  'rma-confirmation': 'Confirmation de RMA',
  'refresh-page': 'Rafraîchir',
  'loading': 'Chargement…',
  'select': 'Sélectionnez l\'adresse',
  'selected': 'Sélectionné',
  'update': 'Modifier l\'adresse',
  'address': 'Adresse',
  'new-address': 'Nouvelle adresse',
  'edit': 'Modifier',
  'update-address': 'Mettre à jour l\'adresse',
  'cancel': 'Annuler',
  'back': 'Retour',
  'select-your-products': 'Sélectionnez vos produits',
  'serial-number': 'Numéro de série',
  'returns-eligibility': 'Éligibilité des retours',
  'warranty': 'Garantie',
  'proof-purchase': 'Preuve d\'achat',
  'purchase-date': 'Date d\'achat',
  'select-date': 'Date d\'achat',
  'how-find-serial-num': 'Comment trouver votre numéro de série?',
  'yes': 'Oui',
  'no': 'Non',
  'choose-file': 'Choisir le fichier',
  'upload-supporting-file': 'Télécharger l\'image d\'accompagnement',
  'remove': 'Retirer',
  'warranty-days-left': '{warrantyDaysRemain} Jours restants',
  'out-warranty': 'Hors garantie',
  'enter-serial': 'Saisir numéro de série',
  'enter-serial-number': 'Veuillez saisir un numéro de série valide.',
  'serial-not-valid': 'Veuillez saisir un numéro de série valide.',
  'serial-num-submitted': 'Numéro de série déjà soumis, veuillez en changer un autre.',
  'file-formats-allowed': 'Formats de fichiers autorisés: JPG, PNG, ZIP. Taille maximale du fichier: 4 Mo.',
  'thank-you-rma-submit': 'Merci pour votre soumission de RMA.',
  'provide-rma-number': 'Veuillez fournir votre numéro RMA à notre équipe du service client si vous nous contactez à propos de ce RMA.',
  'retrieve_rma_status': {
    'text': 'Vous pouvez également récupérer votre statut RMA ou apporter des modifications à votre RMA en vous inscrivant à un ',
    'link': 'Compte Creative Store'
  },
  'product-details': 'Détails du produit',
  'product': 'Produit',
  'rma-details': 'Détails du RMA',
  'service-request2': 'Demande de service',
  'refund': 'Remboursement',
  'replacement': 'Remplacement',
  'rma-status': 'Statut du RMA',
  'expires-date': 'Expire {date}',
  'refund-estimated-cost': 'Remarque: Le montant du remboursement est actuellement une estimation et peut être soumis à d\'autres modifications.',
  'service-fee': 'Frais de service',
  'service-fee-text': 'Des frais de service peuvent être perçus si votre produit retourné montre des signes de dommages accidentels ou d\'abus. Vous serez contacté par e-mail si cela est applicable. ',
  'product-is-defective': 'Le produit est défectueux',
  'repair-status-list': [
    {
      'status': 'Demande de RMA reçue',
      'desc': '<p>Votre demande de RMA est en cours de traitement.</p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>'
    },
    {
      status: 'RMA Approuvé',
      desc: `<p>Veuillez nous renvoyer votre produit. </p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>
              <span style="font-weight: 500;">Voir les instructions de retour</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Veuillez consulter l'e-mail (Objet: Votre demande de retour Creative a été approuvée) et suivre les instructions de retour.
                	Veuillez générer l'étiquette d'expédition pour retour via le lien suivant et saisir les informations comme indiqué:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Numéro de commande:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Code de retour:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Notez qu'une fois l'étiquette d'expédition utilisée, elle ne sera plus utilisable.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Veuillez vous référer à l'e-mail (Objet: Votre demande de retour Creative Labs a été approuvée) pour les instructions de retour.

                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    Votre étiquette d'expédition doit être téléchargée dans les 90 jours.
                    Une fois que l'étiquette est accédée pour la première fois, elle doit être téléchargée ou imprimée dans les 5 jours,
                    après quoi elle ne sera plus accessible.<br>
                    <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Étiquette d'expédition</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Notez qu'une fois l'étiquette d'expédition utilisée, elle ne sera plus utilisable.
                  </p>
                </div>
            </div>`
    },
    {
      status: 'Produit reçu',
      desc: '<p>Nous vérifions votre produit retourné.</p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>',
    },
    {
      status: 'Préparation du remplacement',
      desc: '<p>Nous vérifions la disponibilité de nos stocks pour votre unité de remplacement.</p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>',
    },
    {
      status: 'Préparation de l\'expédition',
      desc: '<p>Nous préparons votre unité de remplacement pour l\'expédition.</p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>',
    },
    {
      status: 'Remplacement expédié',
      desc: '<p>Votre unité de remplacement a été expédiée.   <br />  </p>',
    }
  ],
  'refund-status-list': [
    {
      'status': 'Demande de RMA reçue',
      'desc': '<p>Votre demande de RMA est en cours de traitement.</p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>'
    },
    {
      status: 'RMA Approuvé',
      desc: `<p>Veuillez nous renvoyer votre produit. </p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>
              <span style="font-weight: 500;">Voir les instructions de retour</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Veuillez consulter l'e-mail (Objet: Votre demande de retour Creative a été approuvée) et suivre les instructions de retour.
                	Veuillez générer l'étiquette d'expédition pour retour via le lien suivant et saisir les informations comme indiqué:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Numéro de commande:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Code de retour:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Notez qu'une fois l'étiquette d'expédition utilisée, elle ne sera plus utilisable.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Veuillez vous référer à l'e-mail (Objet: Votre demande de retour Creative Labs a été approuvée) pour les instructions de retour.

                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    Votre étiquette d'expédition doit être téléchargée dans les 90 jours.
                    Une fois que l'étiquette est accédée pour la première fois, elle doit être téléchargée ou imprimée dans les 5 jours,
                    après quoi elle ne sera plus accessible.<br>
                    <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Étiquette d'expédition</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Notez qu'une fois l'étiquette d'expédition utilisée, elle ne sera plus utilisable.
                  </p>
                </div>
            </div>`
    },
    {
      status: "Produit reçu",
      desc: "<p>Nous vérifions votre produit retourné.</p><p><i>(Prend généralement 1 à 2 jours ouvrables)</i></p>",
    },
    {
      status: "Traitement du remboursement",
      desc: "<p>Votre produit a été vérifié et nous traitons votre remboursement<span style='{showAmount}'> de <strong>{RefundAmtActual}</strong></span> $.</p><p><i>(Prend généralement 3 à 5 jours ouvrables)</i></p>",
    },
    {
      status: "Remboursement terminé",
      desc: "<p>Nous avons effectué le remboursement selon votre mode de paiement d'origine. Le traitement de la demande par votre banque peut prendre jusqu'à 30 jours. Veuillez contacter votre banque pour plus d'informations.</p><p><i>(Cela peut prendre jusqu'à 30 jours pour que votre banque traite la réception du remboursement)</i></p>",
    }
  ],
  'what-are-reason': 'Quelle est la raison de votre retour?',
  'which-part-defective': 'Quelle partie de votre produit est défectueuse?',
  'please-select-one': 'Veuillez s\'il vous plait sélectionner une option.',
  'cosmetic-damages': 'Y a-t-il des dommages physiques / cosmétiques sur le produit?',
  'attach-photo': 'Joignez une photo des dommages:',
  'comments': 'Commentaires',
  'enter-comments': 'Décrivez en détail votre demande.',
  'rma-exists': 'Une demande de RMA a été soumise pour ce produit.',
  'rma-created': 'Une demande RMA existe déjà pour ce produit et ne peut pas être recréée.',
  'rma-cancelled': 'Votre demande RMA a été annulée. Si vous avez des questions concernant l\'annulation de votre demande RMA, veuillez nous contacter.',
  'selected-maximum': 'Vous avez sélectionné la quantité maximale autorisée.',

  'shipping-information': 'Informations de livraison',
  'shipping-address': 'Adresse de livraison',
  'select-shipping-address': 'Sélectionner une adresse de livraison',
  'replace-sent-address': 'Votre remplacement sera envoyé à l\'adresse de livraison suivante.',
  'product-purchased-from': 'Produit acheté auprès de',
  'creative-store': 'Creative Store',
  'all-other-retailers': 'Tous les autres revendeurs',
  'product-not-received': 'Non reçu',
  'product-cancelled': 'Annulé',
  'rma-closed': 'Fermé',
  'select-mode-of-contact': 'Sélectionnez la méthode utilisée pour nous contacter.',
  'email-us': 'Contactez-nous par e-mail',
  'your-order': 'Votre commande',
  'refund-amount': 'Montant du remboursement',
  'shipping-charge': 'Frais d\'expédition',
  'store-credit': 'Crédits boutique',
  'tax': 'Taxe',
  'deliver-unable-info':'Nous ne pouvons pas livrer aux boîtes postales, hôtels, motels et dans les territoires d\'outre-mer suivants. <a href="/help/livraison#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">En savoir plus</a>.',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `Avis: Notre site Web fera l'objet d'une maintenance programmée afin de mieux vous servir. Cette maintenance est prévue Dimanche, le 9 Octobre 2022, de 9h00 à 15h00 (GMT +8h00). Pendant ce temps, nos sites internet ne seront pas accessibles.
                      <br><br>
                      Veuillez nous excuser pour la gêne occasionnée. Merci pour votre patience.  `,
  'shipping-country-notice-fr': `Ce site livre uniquement en France et exclut tous les territoires d'outre-mer comme les DOM TOM et les CTOM. Nous ne sommes pas non plus en mesure de livrer aux boites postales, consignes automatiques, hôtels, motels, etc. <a href="/help/livraison#o-livrez-vous" target="_blank">En savoir plus</a>.`
}